<template>
  <el-dialog
    :visible.sync="visibleProxy"
    title="Cấu hình cảnh báo giới hạn học sinh"
    width="620px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="ps-dialog"
  >
    <div class="ps-dialog-intro">
      <div class="ps-dialog-intro__icon"><i class="el-icon-setting" /></div>
      <div>
        <h3>Thiết lập ngưỡng dùng chung</h3>
        <p>Giá trị được lưu trong hệ thống và áp dụng cho tất cả trường khi chạy API test hoặc batch cảnh báo.</p>
      </div>
    </div>

    <el-form
      ref="configForm"
      :model="form"
      :rules="rules"
      v-loading="loading"
      label-position="top"
      @submit.native.prevent
    >
      <div class="ps-alert-config-grid">
        <el-form-item label="Ngưỡng sử dụng (%)" prop="thresholdPercent">
          <el-input-number
            v-model="form.thresholdPercent"
            class="ps-full-width"
            :min="0"
            :max="100"
            :step="1"
            :precision="1"
            controls-position="right"
          />
          <span class="ps-form-hint">Cảnh báo khi đạt từ tỷ lệ này so với giới hạn gói.</span>
        </el-form-item>

        <el-form-item label="Số lượng còn lại tối đa" prop="remainingSlots">
          <el-input-number
            v-model="form.remainingSlots"
            class="ps-full-width"
            :min="0"
            :max="2147483647"
            :step="1"
            :precision="0"
            controls-position="right"
          />
          <span class="ps-form-hint">Cảnh báo khi số lượng còn lại không vượt quá giá trị này.</span>
        </el-form-item>

        <el-form-item label="Gửi lại sau (ngày)" prop="notificationIntervalDays">
          <el-input-number
            v-model="form.notificationIntervalDays"
            class="ps-full-width"
            :min="0"
            :max="2147483647"
            :step="1"
            :precision="0"
            controls-position="right"
          />
          <span class="ps-form-hint">Nhập 0 nếu không giới hạn khoảng cách gửi lại.</span>
        </el-form-item>
      </div>

      <el-form-item label="Tiêu đề thông báo" prop="notificationTitle">
        <el-input
          v-model="form.notificationTitle"
          maxlength="255"
          show-word-limit
          placeholder="Nhập tiêu đề thông báo"
        />
      </el-form-item>

      <el-form-item label="Nội dung thông báo" prop="notificationContent">
        <el-input
          v-model="form.notificationContent"
          type="textarea"
          :rows="4"
          maxlength="1000"
          show-word-limit
          placeholder="Nhập nội dung thông báo"
        />
        <span class="ps-form-hint">
          Biến hỗ trợ: {ten_truong}, {so_hoc_sinh_hien_tai}, {gioi_han_hoc_sinh}, {so_cho_con_lai},
          {so_hoc_sinh_vuot}, {ty_le_su_dung}, {trang_thai}.
          Biến {trang_thai} tự đổi theo trường đang còn trong giới hạn hoặc đã vượt giới hạn.
        </span>
      </el-form-item>
    </el-form>

    <p v-if="config && config.updatedAt" class="ps-form-hint">
      Cập nhật gần nhất: {{ config.updatedAt | formatDate }}
    </p>

    <span slot="footer" class="ps-dialog-footer">
      <el-button @click="visibleProxy = false">Hủy</el-button>
      <el-button type="primary" :loading="saving" @click="submit">Lưu cấu hình</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "PackageLimitAlertConfigDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        thresholdPercent: 90,
        remainingSlots: 5,
        notificationIntervalDays: 7,
        notificationTitle: "Cảnh báo giới hạn học sinh",
        notificationContent: "Trường hiện có {so_hoc_sinh_hien_tai}/{gioi_han_hoc_sinh} học sinh, {trang_thai}. Vui lòng nâng cấp gói để tiếp tục thêm học sinh.",
      },
      rules: {
        thresholdPercent: [
          { required: true, message: "Vui lòng nhập ngưỡng tỷ lệ", trigger: "change" },
          { type: "number", min: 0, max: 100, message: "Ngưỡng tỷ lệ phải từ 0 đến 100%", trigger: "change" },
        ],
        remainingSlots: [
          { required: true, message: "Vui lòng nhập số lượng còn lại", trigger: "change" },
          { type: "number", min: 0, message: "Số lượng còn lại không được âm", trigger: "change" },
        ],
        notificationIntervalDays: [
          { required: true, message: "Vui lòng nhập khoảng cách gửi lại", trigger: "change" },
          { type: "number", min: 0, message: "Khoảng cách gửi lại không được âm", trigger: "change" },
        ],
        notificationTitle: [
          { required: true, message: "Vui lòng nhập tiêu đề thông báo", trigger: "blur" },
          { max: 255, message: "Tiêu đề tối đa 255 ký tự", trigger: "blur" },
        ],
        notificationContent: [
          { required: true, message: "Vui lòng nhập nội dung thông báo", trigger: "blur" },
          { max: 1000, message: "Nội dung tối đa 1000 ký tự", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  watch: {
    visible(value) {
      if (value) this.resetForm();
    },
    config: {
      deep: true,
      handler(value) {
        if (this.visible && value) this.resetForm();
      },
    },
  },
  methods: {
    resetForm() {
      const ratio = Number(this.config && this.config.thresholdRatio);
      const remainingSlots = Number(this.config && this.config.remainingSlots);
      const notificationIntervalDays = this.config && this.config.notificationIntervalDays !== undefined
        ? Number(this.config.notificationIntervalDays) : 7;
      this.form = {
        thresholdPercent: Number.isFinite(ratio) ? ratio * 100 : 90,
        remainingSlots: Number.isFinite(remainingSlots) ? remainingSlots : 5,
        notificationIntervalDays: Number.isFinite(notificationIntervalDays) ? notificationIntervalDays : 7,
        notificationTitle: (this.config && this.config.notificationTitle)
          || "Cảnh báo giới hạn học sinh",
        notificationContent: (this.config && this.config.notificationContent)
          || "Trường hiện có {so_hoc_sinh_hien_tai}/{gioi_han_hoc_sinh} học sinh, {trang_thai}. Vui lòng nâng cấp gói để tiếp tục thêm học sinh.",
      };
      this.$nextTick(() => {
        if (this.$refs.configForm) this.$refs.configForm.clearValidate();
      });
    },
    submit() {
      this.$refs.configForm.validate((valid) => {
        if (!valid) return;
        this.$emit("submit", {
          thresholdRatio: Number(this.form.thresholdPercent) / 100,
          remainingSlots: Number(this.form.remainingSlots),
          notificationIntervalDays: Number(this.form.notificationIntervalDays),
          notificationTitle: this.form.notificationTitle.trim(),
          notificationContent: this.form.notificationContent.trim(),
        });
      });
    },
  },
};
</script>
